export default "__VITE_ASSET__D2e0EvCy__"